import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faFile } from '@fortawesome/free-solid-svg-icons';

export const iconInfo = [
  {
    icon: faLinkedin,
    text: 'LinkedIn',
    link: 'https://www.linkedin.com/in/kevin-schaffter',
  },
  {
    icon: faGithub,
    text: 'Github',
    link: 'https://github.com/kevinschaffter',
  },
  {
    icon: faEnvelope,
    text: 'Email',
    link: 'mailto:kevin@schaffters.com',
  },
  {
    icon: faFile,
    text: 'Resume',
    link: 'https://drive.google.com/file/d/1dM0o_X2okABXe1g8XOQmSwHzAulvCTJm/view?usp=sharing',
  },
];
